import React, { } from "react"
//import { renderToString } from 'react-dom/server'

import rehypeRaw from "rehype-raw"
import remarkDirective from "remark-directive"
import remarkDirectiveRehype from "remark-directive-rehype"
import gfm from 'remark-gfm'

import { useRef } from "react"

import loadable from '@loadable/component'

const ReactMarkdown = loadable(() => import("react-markdown"))






const CustomMarkdown = ({ children, className, skipHtml }) => {
    const ref = useRef()
    //console.log("customMarkdown:" + children);

    const YouTubeVideo = ({ id, children }) => (
        <iframe
            src={'https://www.youtube.com/embed/' + id}
            width="640"
            height="360"
            className="custom-youtube-video"
        >
            {children}
        </iframe>
    )

    const CustomLink = ({ children, url, title, rel, target, underline }) => (

        <a href={(url) ? url : //if is using URL - set url
            (children && children[0] && typeof children[0] == 'object' && children[0].props && children[0].props.href) ? children[0].props.href : // this is to grab de href from React object element
                children //otherwise just set children whatever is
        }
        className={(underline)?'underline-'+underline:''}
            target={target} rel={rel}>
            {title}
        </a>
    )

    const CheckedListItem = ({ children }) => (

        <div className="checked-list-item">{children}</div>

    )

    const CTA = ({ children, title, rel, target, url, color }) => (
        <div className="customMarkdown_cta" >
            <a href={(url) ? url : //if is using URL - set url
                (children && children[0] && typeof children[0] == 'object' && children[0].props && children[0].props.href) ? children[0].props.href : // this is to grab de href from React object element
                    children //otherwise just set children whatever is
            }
                target={target} className={'customMarkdown_cta-link ' + className + ' ' + color} rel={rel}>{title}</a>
        </div>

    )

    const CustomPhoneButton = ({ children, title, rel, color }) => (
        <div className={'customMarkdown-phone-btn ' + color}>
            <a href={'tel:' + children} className={'customMarkdown-phone-btn-link '} rel={rel}>
                <div className="customMarkdown-phone-btn-title">{title}</div>
                <div className="customMarkdown-phone-btn-phone">{children}</div>
            </a>
        </div>
    )
    const CustomEnquiryButton = ({ children, title, rel, color }) => (
        <div className="product-add-btn">
            <a href="#enquiry-popup" aria-label="enquiry button">
                <button className="small-btn-form-action">{title?title:'Enquiry'}</button>
            </a>
        </div>
    )
    const CustomPhoneLink = ({ children, rel, color }) => (
        <div className="customMarkdown-phone-link-wrapper">
            <a href={'tel:' + children} className={`customMarkdown-phone-link-${color}`} rel={rel}>
                {children}
            </a>
        </div>


    )

    const ReadMoreTruncate = ({ children }) => (
        <p>{children}...<span>read more</span></p>
    )

    const CustomParagraph = ({ iconLight, iconDark, footerDisclaimer, children, disclaimer, position }) => {

        return <div className="custom-paragraph-container">
            {/* {React.createElement(element, {className: position}, children)} */}
            {
                iconLight ?
                    <div className={position}>
                        <p className={position}>{footerDisclaimer ? <sup>{footerDisclaimer}</sup> : ""} {children} {disclaimer ? <sup>{disclaimer}</sup> : ""}</p>
                    </div>
                    :
                    iconDark ?
                        <div className={position}>
                            <p className={position}>{footerDisclaimer ? <sup>{footerDisclaimer}</sup> : ""} {children} {disclaimer ? <sup>{disclaimer}</sup> : ""}</p>
                        </div>
                        :
                        
                        <p className={position}>{footerDisclaimer ? <sup>{footerDisclaimer}</sup> : ""} {children} {disclaimer ? <sup>{disclaimer}</sup> : ""}</p>
            }
            

        </div>


    }




    return (
        <>
            <ReactMarkdown
                children={children}
                remarkPlugins={[remarkDirective, remarkDirectiveRehype, gfm]}

                // remarkPlugins={[remarkDirective, remarkDirectiveRehype, gfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                    'youtube-video': YouTubeVideo,
                    'custom-link': CustomLink,
                    'read-more-truncate': ReadMoreTruncate,
                    'cta': CTA,
                    'checked-list-item': CheckedListItem,
                    'custom-phone-btn': CustomPhoneButton,
                    'custom-enquiry' : CustomEnquiryButton,
                    'custom-paragraph': CustomParagraph,
                    'custom-phone-link': CustomPhoneLink

                }}
                className={className}
                skipHtml={skipHtml}

            />
        </>
    )
}

export default CustomMarkdown